import Lottie from "lottie-react";
import removeItem from './removeItem.json';
import aianimation from './aianimation.json';
import audioanimation from './audioanimation.json';
import audiosummary from './audiosummary.json';
import robotanimation from './robotloading.json';
import abmMeeting from './abmanimation.json';
import audiorecording from './audiorecording.json';
import comingsoon from './comingsoon.json';

// Component for RemoveItem animation
const RemoveItemAnimation = () => {
    return <Lottie animationData={removeItem} />;
};

// Component for AiAnimation
const AiAnimation = () => {
    return <Lottie animationData={aianimation} />;
};

const AudioAnimation = () => {
    return <Lottie animationData={audioanimation} />;
};

const AudioSummaryAnimation = () => {
    return <Lottie animationData={audiosummary} />;
};

const RobotLoadingAnimation = () => {
    return <Lottie animationData={robotanimation} />;
};

const AudioAIAnimation = () => {
    return <Lottie animationData={audiorecording} style={{width: 130}}  />;
};

const AbmAIAnimation = () => {
    return <Lottie animationData={abmMeeting} style={{width: 150}} />;
};

const ComingSoonAnimation = () => {
    return <Lottie animationData={comingsoon} style={{width: 100}} />;
};

export {RemoveItemAnimation, AiAnimation, AudioAnimation, AudioSummaryAnimation, RobotLoadingAnimation, AudioAIAnimation, AbmAIAnimation, ComingSoonAnimation};